module.exports = __webpack_public_path__ + "img/icon_count.6e476112.svg";